import { useState } from 'react';
import Modal from "react-modal";

import PhantomLogo from '../assets/phantom.svg';
import SlopeLogo from '../assets/slope.svg';
import ProcessingIcon from '../assets/processingIcon.svg';
import SuccessIcon from '../assets/successIcon.svg';
import ErrorIcon from '../assets/errorIcon.svg';
import SmallLoading from '../assets/small_loading.svg';
import ExitX from '../assets/closing_x.svg';

import '../css/header.css';

function Header() {
    const [isWalletConnected, setIsWalletConnected] = useState(false);
    const [isConnectOpen, setIsConnectOpen] = useState(false);
    const [isSuccessfulOpen, setIsSuccessfulOpen] = useState(false);
    const [isBeforeProcessing, setIsBeforeProcessing] = useState(true);
    const [isPayFeeWalletErrorOpen, setIsPayFeeWalletErrorOpen] = useState(true);
    const [isPayFeeOpen, setIsPayFeeOpen] = useState(false);
    const [paymentError, setPaymentError] = useState(false);
    const wallet = {};

    function toggleConnectModal() {
        console.log('toggle connected');
        setIsConnectOpen(!isConnectOpen);
        if(isWalletConnected) {
            togglePayFeeWalletErrorOpen();
            togglePayFeeModal();
        } else if (!isWalletConnected) {
            togglePayFeeWalletErrorOpen();
        }
    }
    function toggleSuccessModal() {
        setIsSuccessfulOpen(!isSuccessfulOpen);
    }
    function togglePayFeeWalletErrorOpen() {
        if(isWalletConnected) {
            setIsPayFeeWalletErrorOpen(true);
        } else if (!isWalletConnected) {
            setIsPayFeeWalletErrorOpen(false)
        }
    }
    function togglePayFeeModal() {

    }
    function connect(type) {
      try {
        // wallet = ( window.solana || window.torus || window.sollet || window.Slope || window.solflare);
        type.connect();
        console.log("Connected to wallet:", type);
      } catch (err) {
        console.log("Cannot connect to wallet");
      }
    }
    function connectPhantom() {
        connect('phantom');
    }
    function connectSlope() {
        connect('slope');
    }
    function connectSollet() {
        connect('sollet');
    }
    return (
        <>
        <div className="header flex-container center">
            <div className="flex-container horizontal space-between">
                <h2 className="title">Web <span className="three">3</span> Cert</h2>
                {!isWalletConnected && 
                    <button className="connect-wallet" onClick={toggleConnectModal}>Connect Wallet</button>
                }
                {isWalletConnected && 
                    <button className="connected-wallet">Wallet Connected</button>
                }
            </div>
        </div>
        <Modal
        isOpen={isConnectOpen}
        onRequestClose={toggleConnectModal}
        contentLabel="Connect Wallet"
        className="base-modal connect-wallet-modal"
        overlayClassName="base-overlay"
        ariaHideApp={false}
    >
            <div className="center">
                <h1 className="body-large bold">
                    Connect Wallet
                </h1>
                <img className='exit' src={ExitX} alt='gray x used to close modal' onClick={toggleConnectModal} />
                <div className="wallet-list">
                    <div className="listing" onClick={connectPhantom}>
                        <p className="body-large center-aligned">Phantom</p>
                        <img className="wallet-logo" src={PhantomLogo} alt="" />
                    </div>
                    <div className="listing" onClick={connectSlope}>
                        <p className="body-large center-aligned">Slope</p>
                        <img className="wallet-logo" src={SlopeLogo} alt="" />
                    </div>
                    <div className="listing" onClick={connectSollet}>
                        <p className="body-large center-aligned">Sollet</p>
                        <img className="wallet-logo" src={PhantomLogo} alt="" />
                    </div>
                    <div className="listing">
                        <p className="body-large center-aligned">More options</p>
                    </div>
                </div>
            </div>
        </Modal>
        <Modal
            isOpen={isSuccessfulOpen}
            onRequestClose={toggleSuccessModal}
            contentLabel="Successful purchase"
            className="base-modal successful"
            overlayClassName="base-overlay"
            ariaHideApp={false}
        >
            <div className="center">
                <p className="body-large">All done</p>
                <img className='exit' src={ExitX} alt='gray x used to close modal' onClick={toggleSuccessModal} />
                <div className='icon-container'>
                    <img className='icon' src={SuccessIcon} alt="green circle with a darker green checkmark" />
                    <p className='result-msg success'>Payment successful</p>
                </div>
                <p className="body-small centered-text">
                    Thank you for completing the certification form. Once your submission is reviewed by a licensed attorney, we will send the NFT to the wallet that sent the fee.
                </p>
                <button className='filled-connect-wallet' onClick={toggleSuccessModal}>Close</button>
            </div>
        </Modal>
        {!isWalletConnected && 
            <Modal
            isOpen={isPayFeeWalletErrorOpen}
            onRequestClose={togglePayFeeWalletErrorOpen}
            contentLabel="Pay fee"
            className="base-modal pay-fee-error"
            overlayClassName="base-overlay"
            ariaHideApp={false}
        >
                <div className="center">
                    <p className="body-large">Pay fee</p>
                    <img className='exit' src={ExitX} alt='gray x used to close modal' onClick={togglePayFeeWalletErrorOpen} />
                    <div className='icon-container'>
                        <img className='icon' src={ErrorIcon} alt="red circle with a darker red 'x' mark" />
                        <p className='result-msg error'>Wallet not found</p>
                    </div>
                    <p className="body-small centered-text">
                        It looks like there was an error locating your wallet. Please try again to connect your wallet.                </p>
                    <button className='filled-connect-wallet' onClick={() => {toggleSuccessModal();toggleConnectModal();}}>Connect wallet</button>
                </div>
            </Modal>
        }
        {isWalletConnected && 
            <Modal
            isOpen={isPayFeeOpen}
            onRequestClose={togglePayFeeModal}
            contentLabel="Pay fee"
            className="base-modal pay-fee-error"
            overlayClassName="base-overlay"
            ariaHideApp={false}
        >
                <div className="center">
                    <p className="body-large">Pay fee</p>
                    <img className='exit' src={ExitX} alt='gray x used to close modal' onClick={togglePayFeeModal} />
                    {isBeforeProcessing && 
                        <div className='icon-container'>
                            <img className='icon' src={SuccessIcon} alt="green circle with a darker green checkmark" />
                            <p className='result-msg success'>Wallet Connected</p>
                        </div>
                    }
                    {!isBeforeProcessing && 
                        <div className='icon-container'>
                            <img className='icon' src={ProcessingIcon} alt="gray circle with a darker gray loading circle" />
                            <p className='result-msg processing'>Processing transaction...</p>
                        </div>
                    }
                    <div className='token-line-container'>
                        <h1 className='token-label'>Investor Token Fee:</h1>
                        <h1 className='amount-label'>2 SOL</h1>
                    </div>
                    <p className="body-small centered-text">
                        In order to receive your Investor Token NFT you must pay a small application fee. Once your submission is reviewed by a licensed attorney, we will send the NFT to the wallet that sent the fee.
                    </p>
                    {!isBeforeProcessing &&
                        <button className='filled-connect-wallet' onClick={() => {console.log('pay 2 sol')}}><img src={SmallLoading} alt='small white loadin circle' class='btn-img' /></button>
                    }
                    {isBeforeProcessing &&
                        <button className='filled-connect-wallet' onClick={() => {console.log('pay 2 sol')}}>Pay 2 SOL</button>
                    }
                    {paymentError && 
                        <p className='small-error'>Payment failed. Please try again.</p>
                    }
                </div>
            </Modal>
        }
    </>
    );
}
  
export default Header;
  
